
import { PropType, defineComponent } from 'vue';
import { BreadcrumbItem } from './UiBreadcrumbs.vue';

export default defineComponent({
  props: {
    title: {
      type: String,
      required: false,
    },
    breadcrumbs: {
      type: Array as PropType<BreadcrumbItem[]>,
      default: () => [],
    },
  },
});
